import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Form, FormMessage, Accordion, Button } from "lib/components/index";

import { OrderFullDecorator, OrderTransferDecorator } from "lib/decorators/index";
import st from "lib/utils/index";
import { stateSelector, updateTransfer, validate, submit } from "./index";
import * as FormControl from "lib/components/FormControl";

@connect(
  (state) => ({
    initialOrder: stateSelector(state).initialOrder,
    transfer: stateSelector(state).transfer,
    valid: stateSelector(state).valid,
    submitLoading: stateSelector(state).submitLoading,
    saved: stateSelector(state).saved,
    errors: stateSelector(state).errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateTransfer,
        validate,
        submit,
      },
      dispatch
    )
)
export default class AddOrderTransferModalForm extends React.PureComponent {
  componentDidUpdate(prevProps) {
    const { saved, initialOrder, onSave } = this.props;
    if (saved && !prevProps.saved) {
      onSave(initialOrder);
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.submit();
  }

  handlePropChange(prop, value) {
    const { transfer, updateTransfer } = this.props;
    const newTransfer = new OrderTransferDecorator({
      ...transfer,
      [prop]: value,
    });
    updateTransfer(newTransfer);
  }

  render() {
    const { initialOrder, onCancel, transfer, errors, valid, validate, submitLoading } = this.props;

    const senderReceiverOptions = [
      ["supplier", I18n.humanAttributeName("order_transfer", "supplier")],
      ["agent", I18n.humanAttributeName("order_transfer", "agent")],
    ];

    return (
      transfer && (
        <Form onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
          {!!errors.base && <FormMessage error={errors.base} />}

          <div className="fields">
            {initialOrder.agent && transfer.refund && (
              <FormControl.SelectFormGroup
                {...FormControl.addProps(`transfer.sender`, { errors })}
                value={transfer.sender}
                onBlur={validate}
                onChange={this.handlePropChange.bind(this, "sender")}
                label={I18n.humanAttributeName("order_transfer", "sender")}
                required
                options={senderReceiverOptions}
              />
            )}

            {initialOrder.agent && !transfer.refund && (
              <FormControl.SelectFormGroup
                {...FormControl.addProps(`transfer.receiver`, { errors })}
                value={transfer.receiver}
                onBlur={validate}
                onChange={this.handlePropChange.bind(this, "receiver")}
                label={I18n.humanAttributeName("order_transfer", "receiver")}
                required
                options={senderReceiverOptions}
              />
            )}

            <FormControl.SelectFormGroup
              {...FormControl.addProps(`transfer.transfer_type`, { errors })}
              value={transfer.transfer_type}
              onBlur={validate}
              onChange={this.handlePropChange.bind(this, "transfer_type")}
              label={
                transfer.refund
                  ? I18n.humanAttributeName("order_transfer", "refund_type")
                  : I18n.humanAttributeName("order_transfer", "transfer_type")
              }
              required
              options={OrderTransferDecorator.transfer_type_options}
            />

            <FormControl.MoneyFormGroup
              {...FormControl.addProps(`transfer.amount`, { errors })}
              value={transfer.amount}
              onBlur={validate}
              onChange={this.handlePropChange.bind(this, "amount")}
              label={I18n.humanAttributeName("order_transfer", "amount")}
              min={0}
              required
              autoFocus
              defaultCurrency={initialOrder.product_price_currency}
            />

            <FormControl.DateTimeFormGroup
              {...FormControl.addProps(`transfer.transferred_at`, { errors })}
              value={transfer.transferred_at}
              onBlur={validate}
              onChange={this.handlePropChange.bind(this, "transferred_at")}
              label={
                transfer.refund
                  ? I18n.humanAttributeName("order_transfer", "refunded_at")
                  : I18n.humanAttributeName("order_transfer", "transferred_at")
              }
              required
            />
          </div>

          <button type="submit" disabled={submitLoading} hidden />
        </Form>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/AddOrderTransferModal/AddOrderTransferModalForm.jsx